import { Controller } from 'stimulus';

export default class extends Controller {
  static values = { limit: Number };

  #over = false;

  apply({ detail: { current, total } }) {
    const limit = this.hasLimitValue ? this.limitValue : total;
    const over = Number.isFinite(limit) && current > limit;
    const counter = this.element.querySelector('[data-ui--counter-target="counter"]');
    const field = this.element.querySelector('input, textarea');

    counter?.classList.toggle('text-df-danger', over);
    counter?.classList.toggle('text-gray-500', !over);

    // A server-rendered aria-invalid (say, a blank required field) stays until the user edits the
    // value; an over-limit flag set here clears as soon as the count is back under.
    const edited = field && field.value !== field.defaultValue;
    if (over) {
      field?.setAttribute('aria-invalid', 'true');
    } else if (this.#over || edited) {
      field?.removeAttribute('aria-invalid');
    }

    if (over !== this.#over) {
      this.#over = over;
      this.dispatch(over ? 'invalid' : 'valid');
    }
  }
}
